import { merge } from 'lodash'

import { copyByJson, debounce } from '@utils'

import { CacheTable } from '../cacheItem'
import Url from '../Url'

export default {
  props: {
    defaultParams: { type: Object, default: () => ({}) },
    headers: { default: () => [], type: Array, required: true },
    filters: { default: () => [], type: Array },
    params: { default: () => ({}), type: Object },
    orderBys: { default: () => [], type: Array },
    pagination: { default: () => ({}), type: Object },
    options: { default: () => ({}), type: Object },
    isPagination: { type: Boolean, default: true },
    syncParams: Boolean,
    useGrid: Boolean,
    useScrollLoad: Boolean,
    useTop: Boolean,
  },
  data: () => ({
    p_setting: { useScrollLoad: false, useGrid: false },
    cache: new CacheTable(),
    p_loading: false,
    p_items: [],
    p_headers: [],
    p_filters: [],
    p_orderBys: [],
    p_options: {},
    p_pagination: {
      page: 1,
      itemsPerPage: 10,
      hasMoreItems: true,
    },
  }),

  computed: {
    c_options: {
      get() {
        return this.p_options
      },
      set(value) {
        this.p_options = value
        this.checkAndEmit('update:options', value)
      },
    },
    c_loading: {
      get() {
        return this.p_loading
      },
      set(value) {
        this.p_loading = value
        this.checkAndEmit('update:loading', value)
      },
    },
    c_items: {
      get() {
        return this.p_items
      },
      set(value) {
        this.p_items = value
        this.checkAndEmit('update:items', value)
      },
    },
    showHeaders() {
      return this.p_headers.filter((header) => !header.hidden)
    },
    c_headers: {
      get() {
        return this.p_headers
      },
      set(value) {
        this.p_headers = value
      },
    },
    c_filters: {
      get() {
        return this.p_filters
      },
      set(value) {
        this.onUpdateOption({ filters: value })
        this.checkAndEmit('update:filters', this.p_filters)
      },
    },
    c_params: {
      get() {
        return this.params
      },
      set(value) {
        this.checkAndEmit('update:params', this.params)
      },
    },
    c_pagination: {
      get() {
        return this.p_pagination
      },
      set(value) {
        this.onUpdateOption({ pagination: value })
        this.checkAndEmit('update:pagination', this.p_pagination)
      },
    },
    c_orderBys: {
      get() {
        return this.p_orderBys
      },
      set(value) {
        this.onUpdateOption({ orderBys: value })
        this.checkAndEmit('update:orderBys', this.p_orderBys)
      },
    },
    c_setting: {
      get() {
        return this.p_setting
      },
      set(value) {
        this.p_setting = value
        this.checkAndEmit('update:setting', this.p_setting)
      },
    },
    isGrid() {
      return this.useGrid || this.c_setting.useGrid
    },
    isList() {
      return !this.isGrid
    },
    showPagination() {
      return !this.useScrollLoad || this.p_setting.useScrollLoad
    },
    componentsLoad() {
      if (this.isGrid) return 'base-grid'
      return 'base-infinite-scroll'
    },

    defaultFilters() {
      return this.p_headers.reduce((acc, cur) => {
        if (cur.filterable && cur.filterable != false) {
          let item = Object.assign({}, cur)
          if (typeof cur.filterable === 'string') {
            item.value = cur.filterable
          }
          acc.push(item)
        }
        return acc
      }, [])
    },
  },
  watch: {
    'c_setting.useScrollLoad': {
      handler() {
        this.updateItems()
      },
    },
    params: {
      handler: debounce(function() {
        this.reload({ forceToPage1: true })
      }, 100),
      deep: true,
    },
    headers: {
      handler(value) {
        if (value) {
          this.p_headers = value.map((x) => ({ hidden: false, ...x }))
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.setParamsFromQueryUrl()
    this.updateItems()
  },
  methods: {
    checkAndEmit(event, data) {
      if (this.$listeners[event]) {
        this.$emit(event, data)
      }
    },
    setParamsToQueryUrl(params) {
      if (!this.syncParams) return
      params = params || merge({}, this.defaultParams, this.getParams())
      params = copyByJson(params)
      params.paginate = undefined
      window.history.replaceState(null, null, '?' + Url.toQuery(params))
    },
    setParamsFromQueryUrl() {
      if (!this.syncParams) return
      const urlParams = new URLSearchParams(window.location.search)
      const entries = urlParams.entries()
      const params = paramsToObject(entries)

      let pagination = {
        page: params.page || 1,
        itemsPerPage: params.itemsPerPage || 10,
      }
      const { filters, orderBys } = this.handle.reconvertParams(
        params,
        this.headers
      )
      this.onUpdateOption({ filters, orderBys, pagination })
    },
  },
}
function paramsToObject(entries) {
  const result = {}
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value
  }
  return result
}
